export const useThrowErrors = () => {
  const throwFetchError = () => {
    console.error('GraphQL error:')

    throw createError({
      statusCode: 500,
      fatal: true,
      statusMessage: 'Failed to fetch data from backend',
    })
  }

  const throwNotFound = () => {
    throw createError({
      statusCode: 404,
      fatal: true,
      statusMessage: 'Not Found',
    })
  }

  return {
    throwFetchError,
    throwNotFound,
  }
}
